import {
  Physical_Address_Data,
  Fishing_Address_Data,
  GPS_Address_Data,
} from "./TransparencyScoreList";

/* reusable styles */
const styles = {
  container: "flex flex-row justify-center m-10 space-x-4",
  card: "w-[90%] flex flex-col flex-nowrap items-center h-auto max-h-screen bg-white shadow-xl shadow-gray/30 rounded-xl p-4 flex-wrap border border-gray-300 overflow-y-auto",
  cardTitle: "text-lg font-bold mb-4 text-center",
  rowEven: "bg-opacity-50 bg-gray-400",
  rowStyle:
    "flex flex-row text-sm w-full h-10 rounded-md p-2 justify-center items-center font-medium text-black",
  text: "p-2 w-[80%] float-left break-words",
  score: "p-2 float-right font-semibold",
  scoreStyle: "flex-0 text-center",
};

const TransparencyScore = () => {
  const datasets = [
    { title: "Physical Address", data: Physical_Address_Data },
    { title: "GPS Address", data: GPS_Address_Data },
    { title: "Fishing Address", data: Fishing_Address_Data },
  ];

  return (
    <div className={styles.container}>
      {datasets.map((dataset, datasetIndex) => (
        <div key={datasetIndex} className={styles.card}>
          <h3 className={styles.cardTitle}>{dataset.title}</h3>
          <div id={`transparencyTable-${datasetIndex}`}>
            {dataset.data.map(({ id, label, score }, index) => (
              <div
                key={id}
                className={`h-auto ${index % 2 === 0 && styles.rowEven} ${styles.rowStyle}`}
              >
                <div id={`label-${id}`} className={`${styles.text} flex-1`}>
                  {label}
                </div>
                <div id={`transparency-${score}`} className={styles.score}>
                  {score}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TransparencyScore;
